( function ($) {

	$( document ).ready( function() {
		/** header main menu superfish **/
	    $('ul#menu-main-menu').superfish({
	    	delay			: 600,
	    	animation		: {opacity:'show', height:'show'},
	    	animationOut	: {opacity:'hide'},
	    	speed			: 'fast'
	    });
	    
	    
		/** homepage banner swiper slider **/
		var swiper = new Swiper('.__homepage_slider_banner', {
		    loop: true,
		    loopedSlides: 3,
		    spaceBetween: 0,
			speed: 1500,
			autoplay: {
				delay: 7000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
		
		
		/** header links search icon click **/
	    $('.header-links span a.search-btn').click(function(event) {
	        event.preventDefault();
	        $('.header-search-section').stop().slideToggle()
	    });
	    
	    
	    /** foundation datepicker **/
		$('.__dp_field').fdatepicker({
			
		});
     	
		
		/** subpages swiper slider gallery **/
		// var gallerySlider = new Swiper('.__slider_gallery', {
		// 	slidesPerView: 1,
		//     spaceBetween: 13,
		//     loop: true,
		//     loopedSlides: 3,
		//     speed: 500,
		//     slideToClickedSlide: false,
		//     navigation: {
		//         nextEl: '.swiper-btn-next',
		//         prevEl: '.swiper-btn-prev',
  //     		},
		// 	pagination: {
		// 		el: '.swiper-pagination',
		// 		clickable: true,
		// 	},
		// 	breakpoints: {
		// 			// when window width is >= 512px
		// 			512: {
		// 			slidesPerView: 2,
		// 			spaceBetween: 13
		// 		},
		// 			// when window width is >= 768px
		// 			769: {
		// 			slidesPerView: 3,
		// 			spaceBetween: 13
		// 		},
		// 			// when window width is >= 1024px
		// 			1024: {
		// 			slidesPerView: 3,
		// 			spaceBetween: 13
		// 		},
		// 	}
		// });


		/** autoheight repeater content layout */
		// $( ".repeater-content-section .rc-content" ).autoHeight({
		// 	'onResize': true,
		// });
		

		/** add attribute to the function packages button **/
		$('.functions-packages a._3d-flip-book ').attr('href', '#function-packages');
	} );
	
	
	$( window ).resize( function() {
	    
	} );
	
	
	$( window ).load( function() {
	    
	} );
	
	
	$( document ).scroll( function() {

	} );

} ( jQuery ) );



/** moby mobile responsive menu **/
var $ = jQuery;

var mobyMenu = new Moby( {
	menu              : $( '#mobile-menu' ), // The menu that will be cloned
	mobyTrigger       : $( '#open-mobile-menu' ), // Button that will trigger the Moby menu to open
	menuClass		  : 'left-side',
	subMenuOpenIcon   : '<i class="fas fa-caret-down"></i>',
	subMenuCloseIcon  : '<i class="fas fa-caret-up"></i>',
	template          : '<div class="moby-close"><span class="moby-close-icon"></span></div><div class="moby-wrap"><div class="moby-menu"></div></div>'
} );